import { BinderSettingsService } from '@/services/app/binder-settings.service';
import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SettingsDialogService } from '@/services/app/settings-dialog.service';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { UserAccessService } from '@/services/app/user-access.service';
import { DocGeneratorService } from '@/services/api/doc-generator.service';
import { FluidModule } from 'primeng/fluid';
import { FilesService } from '@/services/api/files.service';
import { DocStateService } from '@/services/api/doc-state.service';

@Component({
    selector: 'app-binder-print-settings',
    template: `
    <p-fluid>
    <div class="flex mt-8">
            <div class="flex flex-col gap-4 w-full">
                <div class="flex flex-col md:flex-row gap-4">
                    <div class="flex flex-col gap-2">
                        <label for="price">Show Price</label>
                        <p-toggleswitch inputId="price" [(ngModel)]="showPrice" class="block"></p-toggleswitch>
                        <small class="text-600">Display pricing information on the binder pdf</small>
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="included">Show Included</label>
                        <p-toggleswitch inputId="included" [(ngModel)]="showIncluded" class="block"></p-toggleswitch>
                        <small class="text-600">Show $0 items as (included) in the price column on the pdf</small>
                    </div>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                    <div class="flex flex-col gap-2">
                        <label for="template">Template</label>
                        <p-select [(ngModel)]="template" optionLabel="templateName" optionValue="fileTemplateId"
              [options]="templates" placeholder="Select a Template"
              [appendTo]="'body'"
             [disabled]="!userAccessService.binderEditAccess()">
            </p-select>
                        <small class="text-600">Select the template to use for the binder PDF</small>
                    </div>
                </div>
        <div class="flex flex-col w-full gap-4">
        <span class="text-right mr-3"></span>
        <button pButton pRipple label="Save" icon="pi pi-save" class="w-auto ml-auto" (click)="saveSettings()"></button>
        </div>
            </div>
        </div>
        </p-fluid>  
    `,
    imports: [
      FluidModule,
      ToggleSwitchModule, 
      CommonModule, 
      FormsModule,
      ButtonModule,
      SelectModule
    ],
})
export class BinderPrintSettingsComponent {
  showPrice = false;
  showIncluded = false;

  settingsDialogService = inject(SettingsDialogService);
  binderSettingsService = inject(BinderSettingsService);
  userAccessService = inject(UserAccessService);
docGenerator = inject(DocGeneratorService);
filesService = inject(FilesService);
docStateService = inject(DocStateService);

categoryId = 1;
template: number = 0;
originalTemplate: number = 0;
originalShowPrice: boolean = false;
originalShowIncluded: boolean = false;
cachedStateId: number | null = null;

  constructor(
  ) {
    effect(() => {
      const open = this.settingsDialogService.isDialogOpen();
      const showPrice = this.binderSettingsService.pdfPricing();
      const showIncluded = this.binderSettingsService.showIncluding();
      const template = this.docStateService.getSelectedTemplate(this.categoryId);

      console.log('template from settings', template);

      this.showPrice = showPrice;
      this.showIncluded = showIncluded;
      this.originalShowPrice = showPrice;
      this.originalShowIncluded = showIncluded;

      if(template) {
        this.template = template.fileTemplateId;
        this.originalTemplate = template.fileTemplateId;
        console.log('template from template', template);
      }

      if(!open) {
        this.template = this.originalTemplate;
        this.showPrice = this.originalShowPrice;
        this.showIncluded = this.originalShowIncluded;
      }
    });
   }

   saveSettings() {
    this.binderSettingsService.setPdfPricing(this.showPrice);
    this.binderSettingsService.setShowIncluding(this.showIncluded);
    this.onTemplateChange(this.template);
    this.settingsDialogService.closeDialog();
   }

get templates() {
    return this.filesService.categories().find(c => c.archived !== true && c.fileCategoryId === this.categoryId)?.fileTemplates
}

onTemplateChange(templateId: number) {
    const category = this.filesService.categories().find(c => c.fileCategoryId === this.categoryId);
    if(category) {
    this.docStateService.updateSelectedTemplate(category?.fileCategoryId,templateId);
    }
  };


}
